import { useCallback, useEffect, useState } from 'react'

const KEY = 'kermes.theme'

function apply(dark: boolean) {
  document.documentElement.classList.toggle('dark', dark)
}

/** Light by default; dark is opt-in and remembered per device. */
export function useTheme() {
  const [dark, setDark] = useState(() => localStorage.getItem(KEY) === 'dark')

  useEffect(() => {
    apply(dark)
  }, [dark])

  const toggle = useCallback(() => {
    setDark((prev) => {
      const next = !prev
      localStorage.setItem(KEY, next ? 'dark' : 'light')
      return next
    })
  }, [])

  return { dark, toggle }
}
